import "./_person-option.scss";

const twoLetterInitials = (name) => {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return "—";
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/**
 * A person row - small avatar (two-letter initials, no image support yet -
 * no caller has needed one) with name and, optionally, email stacked below
 * it. Distinct from Table's `PersonCell` (single line, no email) and
 * `EntityCell` (single-initial tile, tone-hashed color, meant for
 * companies/records rather than people) - built for exactly this "pick a
 * person, disambiguate by email" case (a Select's `renderOption`, e.g.
 * `simplifyUser` fields in `renderInput.jsx`), which neither of those two
 * fit. Matches the design's "Single select with search" component
 * (Dropdowns.dc.html) sized up just enough to fit the email as a real
 * second line, on a 22px avatar rather than a bespoke 45px one.
 */
const PersonOption = ({ name, email, className = "" }) => (
  <div className={`person-option ${className}`.trim()}>
    <div className="person-option__avatar">{twoLetterInitials(name)}</div>
    <div className="person-option__text">
      <span className="person-option__name">{name}</span>
      {email && <span className="person-option__email">{email}</span>}
    </div>
  </div>
);

export default PersonOption;
